import { render, staticRenderFns } from "./IconTheme.vue?vue&type=template&id=7725ddf3&"
import script from "./IconTheme.vue?vue&type=script&lang=js&"
export * from "./IconTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7725ddf3')) {
      api.createRecord('7725ddf3', component.options)
    } else {
      api.reload('7725ddf3', component.options)
    }
    module.hot.accept("./IconTheme.vue?vue&type=template&id=7725ddf3&", function () {
      api.rerender('7725ddf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTheme.vue"
export default component.exports